<template>
  <section id="response_message" class="flex items-center py-24 px-4">
    <div class="md:w-9/12 m-auto shadow-mcd-form rounded-mcd-lg px-4 xl:px-48">
      <!-- preloader START -->
      <Preloader v-if="submitStatus == 'LOADING'" />
      <!-- preloader END -->
      <!-- Message START -->
      <div class="py-16">
        <h2 class="text-center speedee-bd text-3xl pb-8">
          {{ message.title }}
        </h2>
        <div class="pt-4">
          <p class="text-center font-light pb-4" v-html="message.content"></p>
        </div>
      </div>
      <!-- Message END -->
    </div>
  </section>
</template>

<script>
import Preloader from "./Preloader";
export default {
  components: {
    Preloader,
  },
  data() {
    return {
      submitStatus: null,
      message: {
        status: null,
        title: "",
        content: "",
      },
    };
  },
  methods: {
    async sendDataToApi(guid) {
      let data = {
        guid: guid,
      };
      let formData = new FormData();
      formData.append("data", JSON.stringify(data));

      //setup headers, method and values
      const settings = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      this.submitStatus = "LOADING";
      this.axios
        .post(
          process.env.VUE_APP_WEBSERVICE_URL + "/?action=optin_unregister",
          formData,
          settings
        )
        .then(
          // get response if success
          async (dataRes) => {
            this.submitStatus = "OK";
            if (dataRes.data.error) {
              this.message.status = "Fehler";
              this.message.title =
                "Leider ist der Link abgelaufen oder er wurde bereits bestätigt.";
              this.message.content =
                "Klicke <a href='/familyplus/?target=abmeldung' class='underline speedee-bd'>hier</a>, um dich abzumelden.";
            }
            if (dataRes.data.success) {
              this.message.status = "Erfolg";
              this.message.title = "Abmeldebestätigung";
              this.message.content =
                "Deine Abmeldung ist hiermit abgeschlossen. Deine Daten wurden gelöscht. Wir vermissen dich jetzt schon!";
            }
          }
          // catch the errors
        )
        .catch(function(error) {
          console.log(error);
        });
    },
  },
  async mounted() {
    // scroll to id
    const id = "response_message";
    const yOffset = -100;
    const element = document.getElementById(id);
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
    // on load check if url params are set and set the in a variable
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // get paramaters by name
    const unregister = urlParams.get("unregister");
    // if parameter unregister ist set, then send data to api
    const checkUnregister = await this.sendDataToApi(unregister);
  },
};
</script>
